<template>
  <!--Page Header-->
  <section
    id="main-banner-page"
    class="position-relative page-header section-nav-smooth parallax blog-detail-header"
  >
    <!-- <div class="overlay overlay-dark opacity-8 z-index-1"></div> -->
    <!-- <div class="container"> -->
    <div id="mapBox" class="mt-3 mb-7">
      <div class="row search-field">
        <!-- <div class="col">
          <input
            v-model="params.keyword"
            v-debounce:200ms="searchItems"
            type="text"
            placeholder="Cari..."
          />
        </div> -->
        <div class="col">
          <select
            id="options"
            v-model="params.id_owner_spklu"
            @change="handleJenisKendaraan"
          >
            <option value="">Semua</option>
            <option
              v-for="item in listMasterOwner"
              :key="item"
              :value="item.id"
            >
              {{ item.nama }}
            </option>
            <!-- <option value="">Semua Jenis Kendaraan</option>
            <option value="Mobil">Mobil</option>
            <option value="Motor">Motor</option> -->
          </select>
        </div>
      </div>

      <MapAll
        v-if="listSPKLU.length > 0"
        @marker-clicked="handleMarkerClicked"
        :listMarker="listSPKLU"
      ></MapAll>
      <!-- <template v-else>
        <MapKosong v-if="isLoading"></MapKosong>
      </template> -->
    </div>
    <!-- </div> -->
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import Datatable from "@/components/kt-datatable/KTDataTable.vue";
import type { Sort } from "@/components/kt-datatable//table-partials/models";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";
import MapAll from "@/views/fe/parts/PetaSPKLU_.vue";
import MapKosong from "@/views/fe/parts/MapKosong.vue";

export default defineComponent({
  components: {
    Datatable,
    MapAll,
    MapKosong,
  },
  setup() {
    var componentKeyMap = 0;

    const tableHeader = ref([
      {
        columnName: "No",
        columnLabel: "id",
        sortEnabled: true,
        columnWidth: 40,
      },
      {
        columnName: "Tahun",
        columnLabel: "tahun_terbit",
        sortEnabled: true,
        columnWidth: 100,
      },
      {
        columnName: "Kategori",
        columnLabel: "category_id",
        sortEnabled: false,
        columnWidth: 175,
      },
      {
        columnName: "Judul",
        columnLabel: "title",
        sortEnabled: true,
        columnWidth: 300,
      },
      {
        columnName: "Aksi",
        columnLabel: "actions",
        sortEnabled: false,
        columnWidth: 60,
      },
    ]);

    const queryParams = reactive({
      limit: 10,
      page: 1,
      sort: "asc",
      orderBy: "id",
      with_users: true,
      category_id: "",
      keyword: "",
      tahun_terbit: "",
    });

    const cmsStore = useCmsStores();
    const rulesList = ref([]);
    const rulesMeta = reactive({
      limit: 10,
      offset: 0,
      page: 1,
      total_data: 0,
    });
    const rulesCategoryList = ref([]);
    const isLoading = ref(false);
    const listTahun = ref([]);

    const offcanvasRightRef = ref<HTMLElement | null>(null);

    const params = reactive({
      limit: 999999,
      keyword: "",
      jenis_kendaraan: "",
      id_owner_spklu: "",
    });
    const listSPKLU = ref([]);
    const getData = async () => {
      await cmsStore.getSpklu(params).then((res) => {
        listSPKLU.value = res.data.data.data;
      });
    };

    watch(listSPKLU.value, getData, { deep: true });

    onMounted(async () => {
      isLoading.value = true;
      await getData();
      await getMasterOwner();
      isLoading.value = false;
    });

    const activedSpklu = reactive({
      nama: "",
      latitude: 0,
      longitude: 0,
      alamat: "",
      jenis_kendaraan: "",
      informasi_daya: "",
      jumlah_stasiun_pengisian: 0,
    });

    const listMasterOwner = ref([]);
    const getMasterOwner = async () => {
      const params = {
        limit: 1000,
      };
      await cmsStore.getOwnerSpklu(params).then((res) => {
        listMasterOwner.value = res.data.data.data;
      });

      // console.log(listMasterOwner.value);
    };

    const handleMarkerClicked = (item: any) => {
      if (item) {
        activedSpklu.nama = item.nama;
        activedSpklu.latitude = item.latitude;
        activedSpklu.longitude = item.longitude;
        activedSpklu.alamat = item.alamat;
        activedSpklu.jenis_kendaraan = item.jenis_kendaraan;
        activedSpklu.informasi_daya = item.informasi_daya;
        activedSpklu.jumlah_stasiun_pengisian = item.jumlah_stasiun_pengisian;
      }
    };

    const handleJenisKendaraan = async () => {
      // console.log(params.id_owner_spklu);
        // console.log(params.value.jenis_kendaraan);
      listSPKLU.value = [];
      isLoading.value = true;
      await getData();
      isLoading.value = false;
    };

    const searchItems = async () => {
      if (params.keyword !== "") {
        queryParams.keyword = params.keyword;
      } else {
        queryParams.keyword = "";
      }
      await getData();
    };

    return {
      tableHeader,
      queryParams,
      rulesList,
      rulesMeta,
      isLoading,
      handleMarkerClicked,
      getFilePath,
      rulesCategoryList,
      listTahun,
      listSPKLU,
      activedSpklu,
      offcanvasRightRef,
      params,
      handleJenisKendaraan,
      searchItems,
      listMasterOwner,
      componentKeyMap
    };
  },
});
</script>

<style scoped>
#mapBox {
  border-radius: 10px;
  height: 600px;
  width: 100%;
  position: relative;
}

.search-field {
  position: absolute;
  top: 10px;
  right: 10px; /* Change from left to right */
  z-index: 1000;
}
</style>
